// extracted by mini-css-extract-plugin
export default {"tableBody":"TableBody_tableBody__UuTUF","shortTableBody":"TableBody_shortTableBody__0rIW+","shortTableBodyEmpty":"TableBody_shortTableBodyEmpty__To7FG"};